const DoneSigning = () => {
  window.close();

  return <div>You're done signing! You can close this window and return to your other tab.</div>;
};

export default DoneSigning;
